/*
 * Part of the RubinRed CMS.
 * @author    Marco Tisi <tisi@workup.it>
 * @license   Proprietary
 * @copyright 2015-2017, Workup Srl
 * @link      http://rubinred.it
 */

import RubinRed from 'js/RubinRed';
window.App = new RubinRed();
window.App.$on('init', () => {
  document.querySelector("body").classList.add("uk-javascript-enabled"); // Aggiungo la classe per identificare se il js è abilitato
  document.querySelectorAll('[data-not-reactive]').forEach(element => {
    element.remove()
  });
  document.querySelectorAll('[data-client-side]').forEach(element => {
    element.classList.remove("uk-hidden");
  });
  let ua = window.navigator.userAgent;
  // var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
  // var re = new RegExp(botPattern, 'i');
  let lighthouse = ua.indexOf("Lighthouse") > -1;
  window.addEventListener("load", function () {
    let sourceLoaded = false;
    if (!lighthouse) {
      setTimeout(function () {
        if (!sourceLoaded) {
          loadSources();
        }
      }, 2000);
    }
    window.addEventListener("mouseover", loadSources);
    window.addEventListener("touchstart", loadSources);
    window.addEventListener("keydown", loadSources);
    window.addEventListener("scroll", loadSources);
    function loadSources() {
      let body = document.getElementsByTagName("body")[0];
      let head = document.getElementsByTagName("head")[0];
      if (window.sessionStorage.getItem("scripts")) {
        let scripts = window.sessionStorage.scripts.split(",");
        loadScripts(0);
        function loadScripts(index_start) {
          let newScript = document.createElement('script');
          newScript.type = 'text/javascript';
          newScript.src = scripts[index_start];
          body.appendChild(newScript);
          newScript.addEventListener("load", function () {
            if (index_start < scripts.length - 1) {
              loadScripts(index_start + 1);
            }
          })
        }
      }
      if (window.sessionStorage.getItem("cookies")) {
        let newScript = document.createElement('script');
        newScript.src = window.sessionStorage.cookies;
        body.appendChild(newScript);
      }
      if (window.sessionStorage.getItem("styles")) {
        let styles = window.sessionStorage.styles.split(",");
        styles.forEach(style => {
          let newStyle = document.createElement('link');
          newStyle.type = 'text/css';
          newStyle.rel = 'stylesheet';
          newStyle.href = style;
          head.appendChild(newStyle);
        })
      }
      if (window.sessionStorage.getItem("googleFonts")) {
        let googleFonts = window.sessionStorage.googleFonts.split(",");
        googleFonts.forEach(font => {
          let newFont = document.createElement('link');
          newFont.rel = 'stylesheet';
          newFont.href = font;
          head.appendChild(newFont);
        })
      }
      window.removeEventListener("mouseover", loadSources);
      window.removeEventListener("touchstart", loadSources);
      window.removeEventListener("keydown", loadSources);
      window.removeEventListener("scroll", loadSources);
      sourceLoaded = true;
    }
  })
})


// WEBPACK FOOTER //
// ./public/themes/frontend/museo/assets/js/app.js